module.exports = __webpack_public_path__ + "media/images/front/pc/dummy/banner01-b3ec56c91fa2a8a75420b0481c102aa9.png";